/*  ========================================================================
    # Index
    ========================================================================  */

// Dependencies
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from '@/App';

const root = document.getElementById('__root');
const props = JSON.parse(root.attributes['data-react-props']?.value || '{}');

// Init App
createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <App {...props} />
      </HelmetProvider>
    </BrowserRouter>
  </StrictMode>
);
